import { useForm } from 'react-hook-form'

import Button from 'src/ui/atoms/Button'
import WrappedCheckbox from 'src/ui/atoms/Checkbox/Wrapped'

import { IProject } from '../../useProjectApi'
import useEsdtToken, { IUpdateEsdtToken } from './useEsdtToken'

const UpdateToken = ({ project }: { project: IProject }) => {
  const { isLoading, handleToken, isWalletConnected } = useEsdtToken({
    payloadKey: 'esdtUpdatePayload',
  })
  let chain = project.data.chain
  const {
    canBurn,
    canMint,
    canAddSpecialRoles,
    canChangeOwner,
    canFreeze,
    canPause,
    canUpgrade,
    canWipe,
  } = project.properties

  const mvxEsdtProperties = [
    { label: 'Pausable', value: 'canPause' },
    { label: 'Freezable', value: 'canFreeze' },
    { label: 'Wipeable', value: 'canWipe' },
    { label: 'Changeable Owner', value: 'canChangeOwner' },
    { label: 'Upgradable', value: 'canUpgrade' },
    { label: 'Can Add Special Roles', value: 'canAddSpecialRoles' },
  ]
  const allEsdtProperties = [
    {
      label: 'Mintable',
      value: 'canMint',
    },
    {
      label: 'Burnable',
      value: 'canBurn',
    },
  ]

  if (chain === 'multiversx') {
    allEsdtProperties.push(...mvxEsdtProperties)
  }

  const handleUpdate = async (data: IUpdateEsdtToken) => {
    await handleToken({
      ...data,
      type: 'update',
      network: project.data.network,
      tokenTicker: project.data.detailedTokenTicker,
    })
  }

  const {
    register,
    handleSubmit,
    formState: { isValid },
  } = useForm({
    mode: 'onChange',
    defaultValues:
      chain === 'multiversx'
        ? {
            canMint,
            canBurn,
            canPause,
            canFreeze,
            canWipe,
            canChangeOwner,
            canUpgrade,
            canAddSpecialRoles,
          }
        : {
            canMint,
            canBurn,
          },
  })

  return (
    chain === 'multiversx' &&
    canUpgrade && (
      <>
        <form
          className="grid gap-4"
          onSubmit={handleSubmit((data) => handleUpdate(data as IUpdateEsdtToken))}>
          <h2 className="text-white">Token Configuration</h2>
          <div className="flex flex-row flex-wrap gap-6">
            {allEsdtProperties.map(({ value, label }: { value: any; label: string }, key) => (
              <WrappedCheckbox size="M" key={key} {...register(value)}>
                {label}
              </WrappedCheckbox>
            ))}
          </div>
          <div className="ml-auto">
            <Button
              name="Update"
              size="M"
              disabled={!isValid || !isWalletConnected}
              loading={isLoading}
            />
          </div>
        </form>
      </>
    )
  )
}

export default UpdateToken
